import { render, staticRenderFns } from "./PlanChangeDetailModal.vue?vue&type=template&id=38189545&lang=pug"
import script from "./PlanChangeDetailModal.vue?vue&type=script&lang=ts"
export * from "./PlanChangeDetailModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports